import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { linkQueries, toFlexDataLink } from './linkQueries';
import type { FlexDataLink } from './types';

const emptyLinkedObjects: FlexDataLink[] = [];

export const useDocumentFlexDataLinks = (contentId: string, enabled = true) => {
  const { data, isLoading, isError } = useQuery({ ...linkQueries.list(contentId), enabled: enabled && !!contentId });

  const linkedObjects = useMemo(() => data?.map(toFlexDataLink) ?? emptyLinkedObjects, [data]);

  return { linkedObjects, isLoading, isError };
};
